<template>
    <modal name="insert_order" :height="'auto'" :adaptive="true" :scrollable="true" class="modern-modal">
        <div class="insert-order-modal">
            <div class="modal-header-modern">
                <div class="modal-icon">
                    <i class="fas fa-shopping-cart"></i>
                </div>
                <div class="modal-title-section">
                    <h4 class="modal-title">Insert Order</h4>
                    <p class="modal-subtitle">Fill in the order details from the customer message</p>
                </div>
                <button class="modal-close-btn" @click="$modal.hide('insert_order')">
                    <i class="fas fa-times"></i>
                </button>
            </div>

            <div class="modal-body-modern">
                <form v-on:submit.prevent="insertOrderForm" class="order-form">
                    <div class="form-instructions">
                        <div class="instruction-item">
                            <i class="fas fa-info-circle"></i>
                            <span>Review the parsed data from the customer message below</span>
                        </div>
                        <div class="instruction-item">
                            <i class="fas fa-edit"></i>
                            <span>Edit any fields that need correction</span>
                        </div>
                    </div>

                    <div class="form-fields">
                        <div v-for="(field, key) in orderForm" :key="key" class="form-field">
                            <label class="field-label">
                                <i class="fas fa-tag"></i>
                                {{ field.key }}
                            </label>
                            <div class="input-wrapper">
                                <input
                                    type="text"
                                    class="modern-input"
                                    v-model="field.value"
                                    :placeholder="`Enter ${field.key.toLowerCase()}`"
                                    required
                                />
                                <div class="input-icon">
                                    <i class="fas fa-pencil-alt"></i>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-preview" v-if="Object.keys(orderForm).length > 0">
                        <h5 class="preview-title">
                            <i class="fas fa-eye"></i>
                            Order Preview
                        </h5>
                        <div class="preview-card">
                            <div v-for="(field, key) in orderForm" :key="key" class="preview-item">
                                <span class="preview-label">{{ field.key }}:</span>
                                <span class="preview-value">{{ field.value || 'Not specified' }}</span>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <div class="modal-footer-modern">
                <button type="button" class="btn-cancel" @click="$modal.hide('insert_order')">
                    <i class="fas fa-times mr-1"></i>
                    Cancel
                </button>
                <button type="submit" class="btn-save" @click="insertOrderForm">
                    <i class="fas fa-save mr-1"></i>
                    Save Order
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    name: 'InsertOrderModal',
    props: {
        orderForm: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        insertOrderForm() {
            this.$emit('insert-order-form');
        }
    }
};
</script>

<style scoped>
/* Modal Styles */
.modern-modal .modal-dialog {
    margin: 2rem auto;
    max-width: 600px;
}

.insert-order-modal {
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

/* Modal Header */
.modal-header-modern {
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
    padding: 20px 24px;
    display: flex;
    align-items: center;
    gap: 16px;
    position: relative;
}

.modal-icon {
    width: 40px;
    height: 40px;
    background: #25d366;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    flex-shrink: 0;
    color: white;
}

.modal-title-section {
    flex: 1;
}

.modal-title {
    font-size: 1.3rem;
    font-weight: 600;
    margin: 0 0 4px 0;
    color: #212529;
}

.modal-subtitle {
    font-size: 0.85rem;
    color: #6c757d;
    margin: 0;
}

.modal-close-btn {
    background: none;
    border: none;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    color: #6c757d;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    flex-shrink: 0;
}

.modal-close-btn:hover {
    background: #e9ecef;
    color: #212529;
}

/* Modal Body */
.modal-body-modern {
    padding: 24px;
}

.form-instructions {
    background: #f8f9fa;
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 24px;
}

.instruction-item {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 0.9rem;
    color: #495057;
    margin-bottom: 8px;
}

.instruction-item:last-child {
    margin-bottom: 0;
}

.instruction-item i {
    color: #007bff;
    width: 16px;
    flex-shrink: 0;
}

/* Form Fields */
.form-fields {
    display: grid;
    gap: 16px;
    margin-bottom: 24px;
}

.form-field {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.field-label {
    font-weight: 600;
    color: #212529;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.9rem;
}

.field-label i {
    color: #6c757d;
    font-size: 0.8rem;
}

.input-wrapper {
    position: relative;
}

.modern-input {
    width: 100%;
    padding: 12px 16px;
    border: 2px solid #e9ecef;
    border-radius: 8px;
    font-size: 1rem;
    transition: all 0.3s ease;
    background: white;
}

.modern-input:focus {
    border-color: #007bff;
    box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
    outline: none;
}

.modern-input::placeholder {
    color: #6c757d;
}

.input-icon {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #6c757d;
    pointer-events: none;
}

/* Form Preview */
.form-preview {
    background: #f8f9fa;
    border-radius: 12px;
    padding: 20px;
    border: 1px solid #e9ecef;
}

.preview-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #212529;
    margin: 0 0 16px 0;
    display: flex;
    align-items: center;
    gap: 8px;
}

.preview-title i {
    color: #007bff;
}

.preview-card {
    background: white;
    border-radius: 8px;
    padding: 16px;
    border: 1px solid #e9ecef;
}

.preview-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid #f8f9fa;
}

.preview-item:last-child {
    border-bottom: none;
}

.preview-label {
    font-weight: 600;
    color: #495057;
    font-size: 0.9rem;
}

.preview-value {
    color: #212529;
    font-size: 0.9rem;
}

/* Modal Footer */
.modal-footer-modern {
    background: #f8f9fa;
    padding: 20px 24px;
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    border-top: 1px solid #e9ecef;
}

.btn-cancel,
.btn-save {
    padding: 10px 20px;
    border-radius: 8px;
    font-weight: 500;
    font-size: 0.9rem;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    border: none;
}

.btn-cancel {
    background: #6c757d;
    color: white;
}

.btn-cancel:hover {
    background: #5a6268;
    transform: translateY(-1px);
}

.btn-save {
    background: #28a745;
    color: white;
}

.btn-save:hover {
    background: #218838;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}

/* Responsive Modal */
@media (max-width: 768px) {
    .modern-modal .modal-dialog {
        margin: 1rem;
        max-width: none;
    }

    .modal-header-modern {
        padding: 20px;
        flex-direction: column;
        text-align: center;
        gap: 12px;
    }

    .modal-title {
        font-size: 1.3rem;
    }

    .modal-body-modern {
        padding: 20px;
    }

    .modal-footer-modern {
        padding: 16px 20px;
        flex-direction: column;
    }

    .btn-cancel,
    .btn-save {
        width: 100%;
        justify-content: center;
    }

    .form-fields {
        gap: 12px;
    }

    .modern-input {
        padding: 10px 14px;
    }
}

/* Animation */
.insert-order-modal {
    animation: modalSlideIn 0.3s ease-out;
}

@keyframes modalSlideIn {
    from {
        opacity: 0;
        transform: translateY(-20px) scale(0.95);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}
</style>
